import React from "react";
import { ConsolidationBasisOptionsResult } from "@common/schemas/domains/accounting/consolidation.schema";
import { CONSOLIDATION_BASIS_LABELS } from "./consolidationBasis.helpers";
import { ConsolidationTableSelect } from "./ConsolidationTableSelect";

interface ConsolidationLedgerSelectProps {
    entityUuid: string;
    ledgerOptions: ConsolidationBasisOptionsResult["ledgerOptionsByEntityUuid"][string];
    selectedLedgerId: string | undefined;
    onLedgerChange: (entityUuid: string, ledgerId: string) => void;
}

export const ConsolidationLedgerSelect: React.FC<
    ConsolidationLedgerSelectProps
> = ({ entityUuid, ledgerOptions, selectedLedgerId, onLedgerChange }) => {
    if (ledgerOptions.length === 0) {
        return "Not consolidated";
    }

    const value = selectedLedgerId ?? ledgerOptions[0].id;
    const options = ledgerOptions.map((ledger) => ({
        value: ledger.id,
        label: CONSOLIDATION_BASIS_LABELS[ledger.basis],
    }));

    return (
        <ConsolidationTableSelect
            value={value}
            options={options}
            onChange={(ledgerId) => onLedgerChange(entityUuid, ledgerId)}
        />
    );
};
